import script from "./CTASection.vue?vue&type=script&setup=true&lang=js"
export * from "./CTASection.vue?vue&type=script&setup=true&lang=js"

import "./CTASection.vue?vue&type=style&index=0&id=38ae3831&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ae3831"]])

export default __exports__